import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChild,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import {
  AD_GROUP_COLUMN_DEFS,
  AdGroupColumnDef,
  AdGroupColumnKey,
  AdGroupColumnTab,
  DEFAULT_AD_GROUP_COLUMNS,
} from '../spark-ad-groups-table/spark-ad-groups-table-columns';

@Component({
  selector: 'bttv2-spark-ad-group-column-picker',
  imports: [],
  templateUrl: './spark-ad-group-column-picker.html',
  styleUrl: './spark-ad-group-column-picker.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SparkAdGroupColumnPickerComponent {
  @ViewChild('bttv2ColumnSelectDialog', { static: false })
  filterDrawerDialog?: ElementRef<HTMLDialogElement>;

  visibleColumns = input.required<Set<AdGroupColumnKey>>();
  columnsChange = output<Set<AdGroupColumnKey>>();

  pendingColumns = signal<Set<AdGroupColumnKey>>(new Set(DEFAULT_AD_GROUP_COLUMNS));
  selectedTab = signal<AdGroupColumnTab>('delivery');

  readonly deliveryCols: AdGroupColumnDef[] = AD_GROUP_COLUMN_DEFS.filter(c => c.tab === 'delivery');
  readonly biddingCols: AdGroupColumnDef[] = AD_GROUP_COLUMN_DEFS.filter(c => c.tab === 'bidding');
  readonly targetingCols: AdGroupColumnDef[] = AD_GROUP_COLUMN_DEFS.filter(c => c.tab === 'targeting');
  readonly advancedCols: AdGroupColumnDef[] = AD_GROUP_COLUMN_DEFS.filter(c => c.tab === 'advanced');

  constructor() {
    effect(() => {
      this.pendingColumns.set(new Set(this.visibleColumns()));
    });
  }

  setTab(tab: AdGroupColumnTab): void {
    this.selectedTab.set(tab);
  }

  getTabClass(tab: AdGroupColumnTab): string {
    if (this.selectedTab() === tab) {
      return 'border-[--primary] text-[--primary]';
    }
    return 'border-transparent text-secondary hover:border-[--border] hover:text-primary';
  }

  getSelectedTabIconClass(tab: AdGroupColumnTab): string {
    if (this.selectedTab() === tab) {
      return 'text-[--primary]';
    }
    return 'text-secondary group-hover:text-primary';
  }

  isChecked(key: AdGroupColumnKey): boolean {
    return this.pendingColumns().has(key);
  }

  toggleColumn(key: AdGroupColumnKey): void {
    this.pendingColumns.update(cols => {
      const next = new Set(cols);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }

  apply(): void {
    this.columnsChange.emit(new Set(this.pendingColumns()));
    this.closeDrawer();
  }

  clear(): void {
    this.pendingColumns.set(new Set(DEFAULT_AD_GROUP_COLUMNS));
  }

  closeDrawer(): void {
    this.filterDrawerDialog?.nativeElement?.close();
  }
}
